// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__BoIgh","label":"CategoryService_label__k46Ua","location":"CategoryService_location__3onjy"};